var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.noEnemy ? _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Enemy')
    }
  })], 1) : _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(3, function (i) {
    return _c('v-col', {
      key: "quest-wave-".concat(_vm.id, "-").concat(3 - i),
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_vm.wave.m_QuestEnemyIDs[3 - i] != -1 ? _c('Enemy', {
      attrs: {
        "id": _vm.wave.m_QuestEnemyIDs[3 - i],
        "level": _vm.wave.m_QuestEnemyLvs[3 - i],
        "qid": _vm.qid
      }
    }) : _vm.wave.m_QuestRandomIDs[3 - i] != -1 ? _c('Random', {
      attrs: {
        "id": _vm.wave.m_QuestRandomIDs[3 - i],
        "qid": _vm.qid
      }
    }) : _vm._e()], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }